export default {"src":"/_next/static/media/pinterest.24a6b8bd.svg","height":52,"width":94,"blurWidth":0,"blurHeight":0};